// extracted by mini-css-extract-plugin
module.exports = {"header":"ForgotPasswordHeader_header__jciKF","headerTitle":"ForgotPasswordHeader_headerTitle__fC9wo","headerIcon":"ForgotPasswordHeader_headerIcon__3pPMs"};